import React, { useState } from 'react'
import {
  Grid,
  Box,
  Button
} from "@material-ui/core"
import { ideaEditStyles } from './IdeaEditStyles'
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';
import ViewQuiltIcon from '@material-ui/icons/ViewQuilt';
import { ValueCanvasEdit } from '../EditIdeaDialogs';
import { useSelector } from 'react-redux';

export const IdeaEditGeneralValueCanvas = () => {
  const classes = ideaEditStyles();
  const { ideaUpdate } = useSelector((state) => state);
  const [ isOpenCanvas, setIsOpenCanvas ] = useState(false)

  function handleOpenCanvas() {
    setIsOpenCanvas(!isOpenCanvas)
  }

  return (
    <>
     <ValueCanvasEdit
        idea={ideaUpdate}
        isOpen={isOpenCanvas}
        onClose={handleOpenCanvas}
      />
      <Grid item xs={12}>
        <Grid container spacing={3} className={classes.root}>
          <Grid item xs={12} className={classes.header}>
            <Box display='flex' alignItems='center'>
              <Box className={classes.iconHeader}>
                <ViewQuiltIcon color="primary" />
              </Box>
              <Box className={classes.titleCard}>value proposition canvas</Box>
            </Box>
            <Button 
              variant="text"
              color="primary"
              startIcon={<AddCircleOutlinedIcon />}
              onClick={handleOpenCanvas}
            >
              adicionar canvas
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
